import React, { useEffect } from 'react';

const UnauthorizedError = ({ history }) => {
  useEffect(() => {
    setTimeout(() => {
      history.push('/login');
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <section
      className="error-main-container"
      data-testid="unauthorized-page-wrapper"
    >
      <article className="error-content">
        <h2 className="status">404</h2>
        <h3 className="access">Access Denied!</h3>
        <p className="message">
          You dont have the access to visit this page. Please check with the
          admin.
        </p>
      </article>
    </section>
  );
};
export default UnauthorizedError;
